import _, { isEmpty } from 'lodash';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { APP_IMG, SHOW_RIBBON } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
const CardH = dynamic(import('src/components/cards/card-h'));

const CardSubMenu = ({ data, eventDataLayer, heading }) => {
  if (_.isEmpty(data[0])) return null;
  const [articles, setArticles] = useState({
    key: null,
    data: data[0]?.data,
    link: data[0]?.link,
    name: data[0]?.nameTh
  });

  return (
    <>
      <WidgetWrapper className={`card-wrapper`}>
        <div className={`card-sub-menu`}>
          <ul className='block-1'>
            {data.map((item, index) => (
              <a
                key={index}
                href={item?.link}
                //! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    ...eventDataLayer,
                    data: {
                      title: item?.nameTh,
                      heading: `${heading}:${item?.nameTh}`
                    }
                  })
                }
              >
                <li
                  aria-hidden='true'
                  onMouseOver={() => {
                    setArticles({
                      key: index,
                      data: item?.data,
                      link: item?.link,
                      name: item?.nameTh
                    });
                  }}
                  onFocus={() => {}}
                >
                  {item?.nameTh}
                </li>
              </a>
            ))}
          </ul>
          <div className='block-2  card-sub-menu-content'>
            {articles?.data.map((item, index) => {
              return (
                <CardH
                  key={index}
                  data={item}
                  shortDate={true}
                  txtStyle={true}
                  eyeBall={false}
                  eventDataLayer={{
                    ...eventDataLayer,
                    data: {
                      ...eventDataLayer?.data,
                      heading: `${heading ?? ''}:${item?.subCategory?.th ?? ''}`,
                      title: item?.title || 'Default Title' // Provide a default value if `title` is potentially null/undefined
                    }
                  }}
                />
              );
            })}
            {isEmpty(articles?.data) ? (
              <div className='empty-logo'>
                <img src={`${APP_IMG}/new-logo-primary.png`} alt='logo' decoding='async' style={{ filter: SHOW_RIBBON === 'true' ? 'brightness(0)' : 'unset' }} />
              </div>
            ) : (
              <div className='btn-readmore'>
                <a href={articles?.link}>ดูทั้งหมด</a>
              </div>
            )}
          </div>
        </div>
      </WidgetWrapper>
    </>
  );
};
export default CardSubMenu;

const WidgetWrapper = styled.div`
  .card-sub-menu {
    display: grid;
    grid-template-columns: 1fr 2fr;

    .block-1 {
      width: 150px;
      display: block;
      list-style: none;
      padding: 0 10px 0 0;
      li {
        color: var(--softblack-color);
        padding: 0px 15px !important;
        border-top-left-radius: 50px;
        border-bottom-left-radius: 50px;
        margin-bottom: 10px;
        margin-right: -10px;
        i {
          float: right;
          color: transparent;
        }
        &:hover {
          background-color: var(--primary-color);
          color: var(--white-color);
          i {
            color: var(--white-color);
          }
        }
      }
    }
  }
  .block-2 {
    grid-gap: 10px;
    display: grid;
    width: 100%;
    padding: 10px;
    border-left: var(--border-default);
    .empty-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 311px;
      img {
        opacity: 0.3;
        max-height: 30px;
      }
    }
    .btn-readmore {
      text-align: center;
      margin: 25px auto 10px;
      a {
        width: 100%;
        padding: 5px 80px;
        background-color: var(--quaternary-color);
        color: var(--tertiary-color);
        border-radius: 20px;
        border: 1px solid var(--quaternary-color);

        &:hover {
          color: var(--white-color);
          background-color: var(--primary-color);
          border: 1px solid var(--primary-color);
        }
      }
    }
  }
`;
